module.exports = __webpack_public_path__ + "static/media/non_ulip.0dbadb37.mp3";